export default __webpack_public_path__ + "static/media/23.1e58b556.svg";